//src/components/common/PrivacyPolicy/CompanyTermsAndPolicy.jsx
import React, { useState } from 'react'
import TermsAndPolicyHeader from './CompanyTermsAndPolicy/TermsAndPolicyHeader'
import TermsAndPolicyFooter from './CompanyTermsAndPolicy/TermsAndPolicyFooter'
import TermsAndPolicyBody from './CompanyTermsAndPolicy/TermsAndPolicyBody'

const CompanyTermsAndPolicy = () => {
  const [activeTab, setActiveTab] = useState('privacy') // Default tab

  return (
    <div className='lg:mx-14 md:mx-8 mx-2'>
      <TermsAndPolicyHeader activeTab={activeTab} setActiveTab={setActiveTab} />
      <TermsAndPolicyBody activeTab={activeTab} />
      <TermsAndPolicyFooter />
    </div>
  )
}

export default CompanyTermsAndPolicy